import { render, staticRenderFns } from "./breif-card.vue?vue&type=template&id=4f74bd73&scoped=true"
import script from "./breif-card.vue?vue&type=script&setup=true&lang=js"
export * from "./breif-card.vue?vue&type=script&setup=true&lang=js"
import style0 from "./breif-card.vue?vue&type=style&index=0&id=4f74bd73&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f74bd73",
  null
  
)

export default component.exports